module.exports = "<ul class=\"scale\">\r\n  {{#list}}\r\n    <li data-info=\"{{.}}\">{{.}}\r\n  {{/list}}\r\n</ul>\r\n"